import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';


export default function ModalInfoWohneinheiten() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Wohneinheiten</h1>
            <p id="modal-description">In der Regel ist hier die Anzahl der Wohnungen im Haus anzugeben. Als Wohneinheit gelten im abgeschlossenen Zusammenhang liegende Räume zum dauerhaften Wohnen und Führen eines eigenen Haushalts, die mindestens über einen abschließbaren Zugang, Zimmer, Küche, Kochnische und Bad/WC verfügen.</p>
             <ModalClose label={"schließen"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

